import React from "react";
import {
  MailOutlined,
  NotificationOutlined,
  FileTextOutlined,
  GlobalOutlined,
  TagOutlined,
  DownOutlined,
} from "@ant-design/icons";

const TEMPLATES = [
  { icon: <MailOutlined />, name: "Welcome Email" },
  {
    icon: <NotificationOutlined />,
    name: "Monthly Newsletter",
    isPublic: true,
    isActive: true,
  },
  { icon: <FileTextOutlined />, name: "Product Update" },
];

/**
 * A tiny looping demo of starting from a template: pick a public
 * template, it fills the composer, pick an audience, send. Purely
 * decorative CSS animation (see .template-pick-demo in index.css);
 * prefers-reduced-motion shows the static composed-and-sent frame
 * instead of looping.
 */
export default function TemplatePickAnimation() {
  return (
    <div className="template-pick-demo" aria-hidden="true">
      <div className="tpk-stage tpk-stage-cards">
        <div className="tpk-cards">
          {TEMPLATES.map((template) => (
            <div
              className={`tpk-card${
                template.isActive ? " tpk-card-active" : ""
              }`}
              key={template.name}
            >
              <span className="tpk-card-icon">{template.icon}</span>
              <span className="tpk-card-name">{template.name}</span>
              {template.isPublic && (
                <span className="tpk-card-badge">
                  <GlobalOutlined /> Public
                </span>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="tpk-stage tpk-stage-compose">
        <div className="tpk-message">
          Hi firstName, here's what's new this month at Mailinflow.
        </div>
        <div className="tpk-dropdown">
          <span className="tpk-dropdown-placeholder">Select audience</span>
          <span className="tpk-dropdown-tag">
            <TagOutlined /> Newsletter Subscribers
          </span>
          <DownOutlined className="tpk-dropdown-chevron" />
        </div>
        <div className="tpk-actions">
          <button type="button" className="tpk-send" tabIndex={-1}>
            Send
          </button>
          <button type="button" className="tpk-schedule" tabIndex={-1}>
            Schedule
          </button>
          <span className="tpk-sent mk-mono">✓ Sent</span>
        </div>
      </div>
    </div>
  );
}
